
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/work9",
      function () {
        return require("private-next-pages/work/work9.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/work9"])
      });
    }
  